import React from 'react'
import styled from '@emotion/styled'
import { Icon } from 'semantic-ui-react'
import { ezMainColor, ezBackColor } from 'variables/styles'

export const AdminContainer = styled.div({
  display: 'flex',
  marginTop:'2rem',
  flex: 1,
  flexDirection: 'column',
  justifyContent:'flex-start',
  width: '100%',
  height: '100vh',

  '.secment':{
    display:'flex',
    flexDirection:'row',
    marginBottom:'1.5rem',
    flexWrap:'wrap',
    rowGap: '1rem',
  },

  '.titleText': {
    fontSize: '1.25rem',
    display:'flex',
    alignItems:'flex-start',
    flexDirection: 'column',
  },
  
  // '.system :nth-child(1)': { order: 1 },
  // '.system :nth-child(2)': { order: 4 },
  // '.system :nth-child(3)': { order: 2 },
  // '.system :nth-child(4)': { order: 3 },
  // '.system :nth-child(5)': { order: 5 },
  // '.system :nth-child(6)': { order: 6 },
  // '.system :nth-child(7)': { order: 7 },
  // '.system :nth-child(8)': { order: 8 },

  'h3':{
    fontSize: '0.9rem',
    marginBottom:'0 !important',
    marginTop: '15px'
  }
})

export const AdminMenuButton = styled.div({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  border: `solid 1px gray`,
  borderRadius: '5px',
  height: '100px',
  width: '120px',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '10px',

  'div.title': {
    color: ezBackColor,
    marginTop: '12px',
    fontSize: '12px',
  },

  '&:hover': {
    border: `solid 1px ${ezBackColor}`,

    svg: {
      color: ezBackColor
    },

    'div.title': {
      color: ezBackColor
    },
  }
})

export const MenuButton = (data) => {
  const { title, icon, onClick, imageCon } = data
  return (
    <AdminMenuButton onClick={onClick}>
      {icon?
        <Icon name={icon} size='big' />
        :null
      }
      {imageCon?
        imageCon()
        :null
      }
      <div style={{ textAlign: 'center', fontWeight: 'bold'}} className='title'>{title}</div>
    </AdminMenuButton>
  )
}
